import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { AuthHttpClientService } from '@service/auth-http-client.service';
import { UserAuthorizationsDto } from '@dto/user-authorizations.dto';

@Injectable({
  providedIn: 'any',
})
export class UserService {
  private readonly url: string = environment.tmnBackApi;

  constructor(private readonly http: AuthHttpClientService) {}

  getAuthorizations(): Observable<UserAuthorizationsDto> {
    return this.http.get<UserAuthorizationsDto>(
      `${this.url}/user/authorizations`
    );
  }
}
